<template>
  <v-container>
    <v-layout row>
      <v-flex xs12>
        <h1>Школы. Список на питание</h1><br>
      </v-flex>
      <v-flex xs12 sm8>
        <h3>{{ currentRegistry.period|period_date }}</h3>
        <h3>{{ currentRegistry.department }}</h3>
        <h3>{{ getStatus(currentRegistry.registry_status).name }}</h3>
      </v-flex>
      <v-flex xs12 sm4>
        <v-btn
          v-if="currentRegistry.registry_status===1"
          class="mb-2"
          @click.native="saveStatusRegistry(2)"
        >Отправить на проверку</v-btn>
        <v-btn
          v-if="inArray(currentRegistry.registry_status, [2, 4])"
          class="mb-2"
          @click.native="saveStatusRegistry(1)"
        >Вернуть статус черновика</v-btn>
      </v-flex>

      <v-flex class="mt-3">
        <v-dialog v-model="dialog" max-width="500px">
        <!--<v-btn slot="activator" color="primary" dark class="mb-2">Добавить</v-btn>-->
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }} {{editedItem.id}}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="editedItem.num_class"
                    label="Номер класса"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="editedItem.letter_class"
                    label="Буква класса"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-text-field
                    v-model="editedItem.amount_of_days"
                    label="Количество дней"
                    type="number"
                    min="0"
                    max="31"
                  ></v-text-field>
                </v-flex>

              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click.native="close">Отменить</v-btn>
            <v-btn flat @click.native="save">Сохранить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <!--<v-toolbar flat color="white">-->

        <!--</v-toolbar>-->
        <v-data-table
          :items="data.results"
          :server-items-length="data.last_page"
          :loading="listLoading.includes(this.fetchDataName)"
          hide-default-footer
          no-results-text="Нет отфильтрованных данных"
          class="elevation-1"
        >
          <template v-slot:header>
            <!--<tr>-->
              <!--<th rowspan="2">r</th>-->
              <!--&lt;!&ndash;<th&ndash;&gt;-->
                <!--&lt;!&ndash;v-for="header in props.headers"&ndash;&gt;-->
                <!--&lt;!&ndash;:key="header.text"&ndash;&gt;-->
                <!--&lt;!&ndash;:align="header.align"&ndash;&gt;-->
                <!--&lt;!&ndash;:width="header.width"&ndash;&gt;-->
              <!--&lt;!&ndash;&gt;&ndash;&gt;-->
                <!--&lt;!&ndash;{{ header.text }}&ndash;&gt;-->
              <!--&lt;!&ndash;</th>&ndash;&gt;-->
            <!--</tr>-->
            <tr>
              <th style="width:50px">Код</th>
              <th colspan="1">
                ФИО<br>
                <v-text-field
                  v-model="search"
                  single-line
                  hide-details
                  @keyup.enter="initialize()"
                ></v-text-field>
              </th>
              <th style="width:50px">Дата<br>рождения</th>
              <th>Категория</th>
              <th style="width:50px">
                Номер класса<br>
                <v-select
                  v-model="num_class"
                  :items="currentRegistry.list_num_class"
                  hide-details
                  @keyup.enter="initialize()"
                ></v-select>
              </th>
              <th style="width:50px">
                Буква класса<br>
                <v-select
                  v-model="letter_class"
                  :items="currentRegistry.list_letter_class"
                  hide-details
                  @keyup.enter="initialize()"
                ></v-select>
              </th>
              <th style="width:50px">
                № закона<br>
                <v-select
                        v-model="npd_num"
                        :items="currentRegistry.list_npd"
                        hide-details
                        @keyup.enter="initialize()"
                ></v-select>
              </th>
              <th style="width:100px">Количество<br>дней</th>
              <th class="justify-center layout mx-0">
                <v-icon
                  large
                  class="mr-2 mt-4"
                  @click="initialize()"
                >
                  mdi-magnify
                </v-icon>
              </th>
            </tr>
          </template>
          <template v-slot:body="{ items }">
            <tbody>
            <tr  v-for="item in items" :key="item.id">
              <td>{{ item.id }}</td>
              <td>{{ item.surname }} {{ item.name }} {{ item.patronymic }}</td>
              <td>{{ item.birthday|short_date }}</td>
              <td>{{ item.category }}</td>
              <td>{{ item.num_class }}</td>
              <td>{{ item.letter_class }}</td>
              <td>{{ item.npd_num }}</td>
              <td>{{ item.amount_of_days }}</td>
              <td>
                <v-icon
                        v-if="currentRegistry.registry_status===1"

                        class="mr-2"
                        @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
              </td>
            </tr>
            </tbody>

          </template>
          <template slot="no-data">
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination
            v-model="pagination.page"
            :length="data.last_page"
          ></v-pagination>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      table: 'list-food-person',
      dialog: false,
      editedItem: {
        id: null,
        num_class: null,
        letter_class: null,
        npd_num: null,
        amount_of_days: null
      },
      defaultItem: {
        id: null,
        num_class: null,
        letter_class: null,
        npd_num: null,
        amount_of_days: null
      },
      search: '',
      num_class: '',
      letter_class: '',
      npd_num: null,
      pagination: {
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0,
        page: 1
      },
      activeTab: null
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    data () {
      return this.$store.getters['schoolFoodListPerson/data']
    },
    formTitle () {
      return this.editedItem.id === null ? 'Добавить запись' : 'Редактировать запись'
    },
    fetchDataName () {
      return 'fetchData' + this.table
    },
    currentRegistry () {
      return this.$store.getters['schoolFood/currentRegistry']
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    pagination: {
      handler () {
        this.initialize()
      },
      deep: true
    }
  },

  // created () {
  //   this.initialize()
  // },

  methods: {
    initialize () {
      this.$store.dispatch('schoolFood/fetchCurrentRegistry', this.$route.params.id)

      this.$store.dispatch('common/clearError')
      this.$store.dispatch('common/pushLoading', this.fetchDataName)

      this.$store.dispatch('schoolFoodListPerson/fetchData', {
        pageId: this.pagination.page,
        search: this.search,
        num_class: this.num_class,
        letter_class: this.letter_class,
        npd_num: this.npd_num,
        table: this.table,
        food_id: this.$route.params.id
      })
        .then(d => {
          this.$store.commit('schoolFoodListPerson/setData', d.data)
        })
        .then(() => {
          this.$store.dispatch('common/popLoading', this.fetchDataName)
        })
        .catch(error => {
          this.$store.dispatch('common/setError', error)
          this.$store.dispatch('common/popLoading', this.fetchDataName)
        })
    },
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      }, 300)
    },
    save (preUser, method) {
      this.editedItem.group = this.groupId
      if (!this.editedItem.amount_of_days) {
        this.editedItem.amount_of_days = 0
      }
      if (!this.editedItem.letter_class) {
        this.editedItem.letter_class = ''
      }
      if (this.editedItem.id !== null) {
        this.$store.dispatch('common/clearError')
        this.$store.dispatch('common/pushLoading', 'updateData')
        this.$store.dispatch('schoolFoodListPerson/updateData', { table: this.table, item: this.editedItem })
          .then(d => {
            this.$store.commit('schoolFoodListPerson/setItem', d.data)
          })
          .then(() => {
            this.$store.dispatch('common/popLoading', 'updateData')
          })
          .catch(error => {
            this.$store.dispatch('common/setError', error)
            this.$store.dispatch('common/popLoading', 'updateData')
          })
      } else {
        alert('Вставка запрещена')
      }
      this.close()
    },
    getStatus (statusId) {
      return this.$store.getters['schoolFood/status'](statusId)
    },
    saveStatusRegistry (statusId) {
      this.$store.dispatch('common/clearError')
      this.$store.dispatch('common/pushLoading', 'saveStatusRegistry')
      let registry
      registry = this.currentRegistry
      registry.registry_status = statusId
      this.$store.dispatch('schoolFood/updateData', { item: registry })
        .then(d => {
          this.$store.commit('schoolFood/setItem', d.data)
        })
        .then(() => {
          this.$store.dispatch('common/popLoading', 'saveStatusRegistry')
        })
        .catch(error => {
          this.$store.dispatch('common/setError', error)
          this.$store.dispatch('common/popLoading', 'saveStatusRegistry')
        })
    },
    inArray: function (needle, haystack) {
      var length = haystack.length
      for (var i = 0; i < length; i++) {
        if (haystack[i] === needle) return true
      }
      return false
    }
  },
  created: function () {
    this.$store.dispatch('schoolFood/fetchStatuses')
    this.initialize()
  }
}
</script>
<style scoped>
  td, th {
    text-align: left;
  }
  th {
    vertical-align: top
  }

</style>
